import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = sessionStorage.getItem('Bearer');
    
    const modifiedReq = request.clone({
      withCredentials: true,
      setHeaders: token ? { 'Authorization': `Bearer ${token}` } : {}
    });

    return next.handle(modifiedReq);
  }
}
